import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../login-service';
import { ToastrModule } from 'ngx-toastr';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss'],
  providers:[ToastrModule]
})
export class ResetComponent implements OnInit {

  newPassword:any;
  retypePassword:any;
  submitted:boolean=false;
  form: FormGroup = new FormGroup({});
  userID:any;
  emailRoute:any;
  constructor(private fb: FormBuilder, private router:Router,private activateRoute:ActivatedRoute,private loginService:LoginService) {

      this.userID = this.activateRoute.snapshot.params['userID'];
      this.emailRoute=this.activateRoute.snapshot.params['email'];
  
       console.log(this.userID) 
    
    this.form = fb.group({
      newPassword: ['', [Validators.required,Validators.minLength(6)]],
      retypePassword: ['', [Validators.required]]
    }, { 
      validator: this.ConfirmedValidator('newPassword', 'retypePassword')
    })
  }

  ngOnInit(): void {
  }
  
  
  
    
  get f(){
    return this.form.controls;
  }

  Submit(){
    this.newPassword=this.form.value.newPassword;
    this.retypePassword=this.form.value.retypePassword;

    this.submitted=true;
    
    if(this.form.invalid){
    return;
    }
    else{
      const json={
        emailparm:this.emailRoute,
        useridparm:this.userID,
        passwordparm:this.newPassword        
      }
     
     
     this.loginService.ResetPassword(json).subscribe(data=>
      {

      });
     this.router.navigate(['/login'])
    
    }
  }

  ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

}
